export const ROUTES = {
    LOGIN: "/login",
    SIGN_UP: "/sign-up",
    FORGOT_PASSWORD: "/forgot-password",
    RESET_PASSWORD: "/reset-password",
    CREATE_STUDENT_PROFILE: "/create-student-profile",

    DASHBOARD: "/dashboard",
    ACADEMIC_COURSES: "/academic-courses",
    FORUM: "/forum",
    PROFILE: "/profile",
    STUDENT_NOTES: "/student-notes",
    CHANGE_PASSWORD: "/profile/change-password",
    EDIT_PROFILE: "/profile/edit-profile",
    ACADEMIC_COURSE_DETAIL: "/academic-courses/detials",

    NEF_PAYMENT_LISTING: "/mG4aDjFqrc33YcWrPiYRu0e9Wf4IdaqWFkCpOeZKd28d4sKcSPsqcUEVLlqIFhUaTcG8i8VWmfeAcrnU2S14IBIN4ePMjz66dCJc6EFNSCGC0cb8GYAkhe3Af0Jxb7I3Up9d3bF73ex4Wgdbdia3wW0f28TVN82bH1A6ZSrFLrrerlmOzHK9aLC92ypuK7qdbEQj6c6B",
    NEF_SUBMISSION: "/VWmfeAcrnU2S14IBIN4ePMjz66dCJc6EFNSCGC0cb8GYAkhe3Af0Jxb7I3Up9d3bF73ex4Wgdbdia3wW0f28TVN82bH1A6ZSrFLrrerlmOzHK9aLC92ypuK7qdbEQj6c6BmG4aDjFqrc33YcWrPiYRu0e9Wf4IdaqWFkCpOeZKd28d4sKcSPsqcUEVLlqIFhUaTcG8i8",

    IIT_BOMBAY_TECHFEST_SUBMISSION: "/A9B3C7D1E4F5G6H8J2K0L1M9N3P7Q8R0S4T5U6V7W8X2Y9Z0A1B3C4D5E6F7G8H9J0K1L2M3N4P5Q6R7S8T9U0V1W2X3Y4Z5",
    IIT_BOMBAY_TECHFEST_CERTIFICATE: "/iitkanpur-techkriti-certificate-download",
    IIT_BOMBAY_TECHFEST_LISTING: "/wW0f28TVN82bH1A6ZSrFLrrerlmOzHK9aLC92ypuK7qdbEQj6cGC0cb8GYAkhe3Af0Jxb7I3Up9U2S14IBIN4ePMjz66dCJc6EFNSCGC0cd3bF73ex4",

    ADMIN_DASHBOARD: "/admin/dashboard",
    ADMIN_STUDENTS: "/admin/students",
    ADMIN_ATTENDANCE: "/admin/attendance-list",
    ADMIN_TEACHERS: "/admin/teachers",
    ADMIN_ADD_TEACHERS: "/admin/teachers/add",
    ADMIN_CURRICULUM_LIST: "/admin/curriculum-list",
    ADMIN_PROFILE: "/admin/profile",
    ADMIN_EDIT_PROFILE: "/admin/profile/update",
    ADMIN_CHANGE_PASSWORD: "/admin/profile/change-password",

    BOOKS_SELLING_HOME_PAGE: "/books-courses",
    BOOKS_SELLING_DETAILS_PAGE: "/books-courses/details",
    BOOKS_SELLING_CART_PAGE: "/books-courses/cart",
    BOOKS_SELLING_CHECKOUT_PAGE: "/books-courses/cart/checkout",
    BOOKS_SELLING_BOOK_DASHBOARD: "/books/dashboard",
    BOOKS_USER_LIBRARY: "/books/dashboard",
    BOOKS_SELLING_BOOK_DASHBOARD_DETAILS: "/books/dashboard/details",
    BOOKS_LESSON_READER: "/books/dashboard/reader",
}
